




















import { Component, Vue } from 'vue-property-decorator'
import VModal from '@/components/VModal.vue'
import VButton from '@/components/VButton.vue'
import { Action } from 'vuex-class'
import * as types from '@/store/account/types'

@Component({ components: { VModal, VButton } })
export default class Verify extends Vue {
  @Action('verifyEmail', { namespace: 'account' }) verifyEmail!: types.VerifyEmailAction
  private verified = false
  private verifying = false
  private error = false

  private created () {
    this.verifyEmail(this.$route.params.token)
      .then(() => { this.verified = true })
      .catch(() => { this.error = true })
      .finally(() => { this.verifying = false })
  }
}
